import { Search, Filter, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  type?: "no-results" | "no-data";
  onClearFilters?: () => void;
  hasActiveFilters?: boolean;
}

export const EmptyState = ({ 
  type = "no-results", 
  onClearFilters,
  hasActiveFilters = false 
}: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center animate-fade-in">
      {/* Illustration */}
      <div className="relative mb-6">
        <div className="w-24 h-24 rounded-full bg-muted flex items-center justify-center">
          {type === "no-results" ? (
            <Search className="w-10 h-10 text-muted-foreground/50" />
          ) : (
            <MapPin className="w-10 h-10 text-muted-foreground/50" />
          )}
        </div>
        {type === "no-results" && (
          <div className="absolute -bottom-1 -right-1 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Filter className="w-5 h-5 text-primary/60" />
          </div>
        )}
      </div>

      {/* Text */}
      <h3 className="font-display font-semibold text-lg text-foreground mb-2">
        {type === "no-results" ? "Brak wyników" : "Brak schronisk"}
      </h3>
      <p className="text-sm text-muted-foreground max-w-[280px] mb-4">
        {type === "no-results" 
          ? "Nie znaleziono schronisk pasujących do wybranych filtrów. Spróbuj zmienić kryteria wyszukiwania."
          : "Nie udało się załadować listy schronisk. Odśwież stronę, aby spróbować ponownie."
        }
      </p>

      {/* Action */}
      {type === "no-results" && hasActiveFilters && onClearFilters && (
        <Button 
          variant="outline" 
          size="sm"
          onClick={onClearFilters}
          className="gap-2"
        >
          <Filter className="w-4 h-4" />
          Wyczyść filtry
        </Button>
      )}
    </div>
  );
};
